<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'" :modal-append-to-body="false" :show-close="false"
    :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
      label-width="80px">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="dataForm.username" placeholder="登录用户名" :disabled="idVis"></el-input>
      </el-form-item>
      <el-form-item label="企业">
        <el-select v-model="dataForm.companyId" placeholder="请选择企业" style="width: 100%">
          <el-option v-for="item in companyOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input v-model="dataForm.mobile" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="E-mail" prop="email">
        <el-input v-model="dataForm.email" placeholder="E-mail"></el-input>
      </el-form-item>
      <!--        <el-select v-model="dataForm.status" placeholder="请选择状态" style="width: 100%">-->
      <!--          <el-option-->
      <!--            v-for="item in enumOption"-->
      <!--            :key="item.value"-->
      <!--            :label="item.label"-->
      <!--            :value="item.value">-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>--> <!--      <el-form-item label="状态">-->

      <el-form-item label="备注" prop="description">
        <el-input v-model="dataForm.description" placeholder="描述信息"></el-input>
      </el-form-item>
      <el-form-item label="角色" v-show="roleVis" prop="roleIds">
        <el-select v-model="dataForm.roleIds" multiple placeholder="请选择角色" style="width: 100%">
          <el-option v-for="item in roleOption" :key="item.roleId" :label="item.roleName" :value="item.roleId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报表推送" style="text-align: left;">
        <el-checkbox label="周报推送" v-model="dataForm.isOpenWeek" prop="isOpenWeek"></el-checkbox>
        <el-checkbox label="月报推送" v-model="dataForm.isOpenMonth" prop="isOpenMonth"></el-checkbox>
        <el-checkbox label="年报推送" v-model="dataForm.isOpenYear" prop="isOpenYear"></el-checkbox>
      </el-form-item>
      <el-form-item label="告警功能" style="text-align: left;">
        <el-checkbox label="短信告警" v-model="dataForm.isOpenSms" prop="isOpenSms"></el-checkbox>
        <el-checkbox label="邮件告警" v-model="dataForm.isOpenEmail" prop="isOpenEmail"></el-checkbox>
        <el-checkbox label="公众号告警" v-model="dataForm.isOpenWechat" prop="isOpenWechat"></el-checkbox>
        <el-checkbox label="客户端告警" v-model="dataForm.isOpenClient" prop="isOpenClient"></el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      idVis: false,
      roleVis: true,
      companyOption: [],
      enumOption: [],
      roleOption: [],
      dataForm: {
        id: 0,
        username: '',
        password: '',
        nickName: '',
        companyId: '',
        dataLevel: '',
        email: '',
        mobile: '',
        isOpenWeek:false,
        isOpenMonth:false,
        isOpenYear:false,
        isOpenSms:false,
        isOpenEmail:false,
        isOpenWechat:false,
        isOpenClient:false,
        avatar: '',
        status: '',
        sign: '',
        createTime: '',
        modifyTime: '',
        lastLoginTime: '',
        isTab: '',
        theme: '',
        description: '',
        parentUid: '',
        roleIds: []
      },
      dataRule: {
        username: [
          {required: true, message: '登录用户名不能为空', trigger: 'blur'}
        ],
        companyId: [
          {required: true, message: '企业ID不能为空', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '状态不能为空', trigger: 'blur'}
        ],
        roleIds: [
          {required: true, message: '角色不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.roleVis = true
      this.visible = true
      this.idVis = false
      this.getCompanyOption()
      this.getStatusOption()
      this.getRoleOption()
      this.dataForm = {}
      if (id) {//修改
        this.idVis = true
        //普通用户隐藏角色栏
        let user = JSON.parse(sessionStorage.getItem("user") || "[]")
        if (user.id === id && user.roleId !== '1' && user.roleId !== '2') {
          this.roleVis = false
        }
        this.dataForm.id = id
        this.$nextTick(() => {
          this.$http({
            url: this.$http.adornUrl("/user/list"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
              let roles = data.data.rows[0].roleId.split(",")
              if(this.dataForm.isOpenWeek == 1) {
                this.dataForm.isOpenWeek = true;
              }
              if(this.dataForm.isOpenMonth == 1) {
                this.dataForm.isOpenMonth = true;
              }
              if(this.dataForm.isOpenYear == 1) {
                this.dataForm.isOpenYear  = true;
              }
              if(this.dataForm.isOpenWechat == 1) {
                this.dataForm.isOpenWechat = true;
              } 
              if (this.dataForm.isOpenClient == 1) {
                this.dataForm.isOpenClient = true;
              } 
              if(this.dataForm.isOpenSms == 1) {
                this.dataForm.isOpenSms = true;
              }
              if(this.dataForm.isOpenEmail == 1) {
                this.dataForm.isOpenEmail  = true;
              }
              //数据回显，select的字段类型要对应上
              if (roles) {
                let array = []
                for (let i = 0; i < roles.length; i++) {
                  this.roleOption.map(r => {
                    if (r.roleId == roles[i]) {
                      array.push(parseInt(roles[i]))
                    }
                  })
                }
                this.dataForm.roleIds = array
              }
            }
          })
        })
      }

    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/user/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'username': this.dataForm.username,
              'companyId': this.dataForm.companyId,
              'email': this.dataForm.email,
              'mobile': this.dataForm.mobile,
              'isOpenWeek':this.dataForm.isOpenWeek ? 1 : 0,
              'isOpenMonth':this.dataForm.isOpenMonth ? 1 : 0,
              'isOpenYear':this.dataForm.isOpenYear ? 1 : 0,
              'isOpenWechat': this.dataForm.isOpenWechat ? 1 : 0, 
              'isOpenClient': this.dataForm.isOpenClient ? 1 : 0, 
              'isOpenSms':this.dataForm.isOpenSms ? 1 : 0,
              'isOpenEmail':this.dataForm.isOpenEmail ? 1 : 0,
              'status': this.dataForm.status,
              'ssex': this.dataForm.ssex,
              'description': this.dataForm.description,
              'roleIds': this.dataForm.roleIds
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取企业option
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl("/company/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.companyOption = data.data.companyOption
        }
      })
    },
    //获取状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/0"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.enumOption = data.data.enumOption
        }
      })
    },
    //获取角色
    getRoleOption() {
      this.$http({
        url: this.$http.adornUrl("/role/list"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.roleOption = data.data.rows
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/user-add-or-update.vue